import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { type ReactElement } from "react";
import DataBrowsePage from "@/components/dataBrowse/dataBrowsePage";
import { asArray } from "@/schemas/dataAssetSearchSchema";
import { ManifestType } from "@/apiClient";

const searchSchema = z.object({
  path: z.string().optional().default("/"),
  realAssetDeploymentPublicId: z.string().optional(),
  manifestType: z.nativeEnum(ManifestType).optional(),
  search: z.string().optional().default(""),
  fileTypes: asArray.optional(),
  dateModified: z.string().optional().default(""),
  dateFrom: z.string().optional().default(""),
  dateTo: z.string().optional().default(""),
});

export const Route = createFileRoute("/data/browse/")({
  component: DataBrowse,
  validateSearch: searchSchema,
});

function DataBrowse(): ReactElement {
  return <DataBrowsePage />;
}
